import { useSavingsDepositDialog } from './logic/useSavingsDepositDialog'
import { SavingsDepositView } from './views/SavingsDepositView'
import { SuccessView } from './views/SuccessView'
import { Token } from '@/domain/types/Token'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface SavingsDepositContainerProps {
  initialToken: Token
  savingsToken: Token
  chainId?: number
  closeDialog: () => void
  onSuccess?: () => void
}

function SavingsDepositDialogContentContainer(props: SavingsDepositContainerProps) {
  const {
    selectableAssets,
    assetsFields,
    form,
    tokenToDeposit,
    pageStatus,
    txOverview,
    actionsViewState,
    underlyingToken,
    savingsToken,
    accountName,
    stusdsWarningData,
    activeIntegrator,
  } = useSavingsDepositDialog({
    savingsToken: props.savingsToken,
    initialToken: props.initialToken,
    chainId: props.chainId,
    onSuccess: props.onSuccess,
  })

  if (pageStatus.state === 'success') {
    return <SuccessView tokenToDeposit={tokenToDeposit} closeDialog={props.closeDialog} />
  }

  return (
    <SavingsDepositView
      underlyingToken={underlyingToken}
      savingsToken={savingsToken}
      form={form}
      selectableAssets={selectableAssets}
      assetsFields={assetsFields}
      txOverview={txOverview}
      actionsViewState={actionsViewState}
      accountName={accountName}
      stusdsWarningData={stusdsWarningData}
      activeIntegrator={activeIntegrator}
    />
  )
}

const SavingsDepositDialogContentContainerWithSuspense = withSuspense(
  SavingsDepositDialogContentContainer,
  DialogContentSkeleton,
)
export { SavingsDepositDialogContentContainerWithSuspense as SavingsDepositDialogContentContainer }
